import type { AuthMe } from '@/features/auth/types/auth'
import { createStore } from './createStore'

type AuthState = {
  currentUser: AuthMe | null
  isRefreshingMe: boolean
  setCurrentUser: (currentUser: AuthMe) => void
  setIsRefreshingMe: (isRefreshingMe: boolean) => void
  removeCurrentUser: () => void
  isAuthenticated: () => boolean
}

export const useAuthStore = createStore<AuthState>(
  (set, get) => ({
    currentUser: null,
    isRefreshingMe: false,
    setCurrentUser: currentUser => set({ currentUser }),
    setIsRefreshingMe: isRefreshingMe => set({ isRefreshingMe }),
    removeCurrentUser: () => set({ currentUser: null, isRefreshingMe: false }),
    isAuthenticated: () => !!get().currentUser,
  }),
  'AuthStore',
)
